const Choice = (props) => {
    return (
        <div onClick={props.function} className="mt-4 choice">
            <i className="fa-solid fa-xmark" />
            <span className="px-2"><span className="type-info">{props.type}:</span> {props.children}</span>
        </div>
    );
}

export default Choice;